var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M4.68889 1.46875H17.4444V18.5156V19.1562H13.9111V18.5156V16.875V16.2344H14.7556H15.7556V15.2344V13.5938V12.9531V12.5938V11.9531V10.3125V9.3125H14.7556H12.9889V8.67188V8.03125H13.8333H14.8333V7.03125V5.39062V4.39062H13.8333H12.9889V3.75V2.75H11.9889H10.1444H9.14444V3.75V4.39062H8.3H7.3V5.39062V7.03125V8.03125H8.3H9.14444V8.67188V9.3125H7.37778H6.37778V10.3125V11.9531V12.5938V12.9531V13.5938V15.2344V16.2344H7.37778H8.22222V16.875V18.5156V19.1562H4.68889V18.5156V1.46875ZM11.9111 15.875H10.2222V15.2344V13.5938V12.9531V12.5938V11.9531V10.3125V9.67188H11.9111V10.3125V11.9531V12.5938V12.9531V13.5938V15.2344V15.875Z",
    stroke: "#0E376E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.f622eb55e24d572677b533bcc08f3dd1.svg";
export { ForwardRef as ReactComponent };